<template>
    <ValidationObserver
        tag="div"
        class="buy-sell-widget px-2"
        v-slot="{ passes }"
    >
        <form
            @submit.prevent="passes(formSubmit)"
            class="currency_validate"
            method="post"
            :class="flex && 'row'"
        >
            <ValidationProvider
                tag="div"
                rules="required"
                v-slot="{ errors }"
                name="currency"
                class="mb-3"
                :class="flex && 'col-xl-4 mb-0'"
            >
                <label class="form-label">Currency</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <label class="input-group-text"
                            ><i class="cc BTC-alt"></i
                        ></label>
                    </div>
                    <select
                        v-model="currency"
                        name="currency"
                        class="form-control"
                    >
                        <option value="">Select</option>
                        <option value="bitcoin">Bitcoin</option>
                        <option value="litecoin">Litecoin</option>
                    </select>
                    <label class="error" for="currency">{{ errors[0] }}</label>
                </div>
            </ValidationProvider>

            <ValidationProvider
                tag="div"
                rules="required"
                v-slot="{ errors }"
                name="method"
                class="mb-3"
                :class="flex && 'col-xl-4 mb-0'"
            >
                <label class="form-label">Payment Method</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <label class="input-group-text"
                            ><i class="fa fa-bank"></i
                        ></label>
                    </div>
                    <select class="form-control" v-model="method" name="method">
                        <option value="">Select</option>
                        <option value="bank"
                            >Bank of America ********45845</option
                        >
                        <option value="master"
                            >Master Card ***********5458</option
                        >
                    </select>
                    <label class="error" for="method">{{ errors[0] }}</label>
                </div>
            </ValidationProvider>

            <div class="mb-3" :class="flex && 'col-xl-4 mb-0'">
                <label class="form-label">Enter your amount</label>
                <ValidationProvider
                    tag="div"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="0.0214 BTC"
                            v-model="currency_amount"
                        />

                        <input
                            type="text"
                            class="form-control"
                            placeholder="0.0214 BTC"
                            v-model="usd_amount"
                        />

                        <label class="error" for="method">{{
                            errors[0]
                        }}</label>
                    </div>
                </ValidationProvider>
                <div class="d-flex justify-content-between mt-3" v-if="!flex">
                    <p class="mb-0">Monthly Limit</p>
                    <h6 class="mb-0">$49750 remaining</h6>
                </div>
            </div>
            <div class="col-12" v-if="flex">
                <div
                    class="d-flex justify-content-between align-items-center mb-3"
                >
                    <!-- <p class="mb-0">Monthly Limit</p> -->
                    <h6 class="mb-0">$49750 remaining</h6>
                    <button
                        type="submit"
                        name="submit"
                        class="btn btn-success px-5 mt-2"
                    >
                        Exchange Now
                    </button>
                </div>
            </div>
            <button
                v-if="!flex"
                type="submit"
                name="submit"
                class="btn btn-success w-100"
            >
                Exchange Now
            </button>
        </form>
    </ValidationObserver>
</template>

<script scoped>
// import "./validation/Intro";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "CurrencyForm",
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        flex: Boolean,
    },
    data() {
        return {
            // erros: {},
            currency: "",
            method: "",
            currency_amount: "",
            usd_amount: "",
            submitted: false,
        };
    },
    methods: {
        formSubmit() {
            console.log("Submitting to server!");
        },
    },
};
</script>
